import styled from '@emotion/styled';
import { Box } from '@mafc/trolly';
import COLORS from 'theme/colors';
import SPACINGS from 'theme/spacings';
import TYPOGRAPHY from 'theme/typography';

export const MainContainer = styled(Box)`
  align-items: center;
  padding-top: ${SPACINGS[16]};
  padding-bottom: ${SPACINGS[16]};
  font-size: ${TYPOGRAPHY.SIZE[16]};
  line-height: ${TYPOGRAPHY.SIZE[18]};
  color: ${COLORS.MINE_SHAFT};
`;

export const Spacer = styled(Box)`
  html[dir='rtl'] & {
    margin-left: ${SPACINGS[8]};
  }
  html[dir='ltr'] & {
    margin-right: ${SPACINGS[8]};
  }
`;

export const OnDeliveryText = styled(Box)`
  display: flex;
  width: 80px;
  font-size: ${TYPOGRAPHY.SIZE[10]};
  font-weight: ${TYPOGRAPHY.WEIGHT[700]};
  align-items: center;
  color: ${COLORS.BLACK};
`;
